import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [ 'mobile', 'desktop' ]

    connect() {
        if (IBE.isMobile) {
            this.mobileTarget.classList.remove('d-none')
            this.desktopTarget.classList.add('d-none')
            this.mobileTarget.addEventListener('change', event => window.location = event.target.value)
        }
    }

}